/**
 * Footer Component
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">&copy; 2024 Jim McGowen</div>
    </div>
  )
}

export default Footer
